var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedTrashSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12899_13746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.75 4H2.91667H12.25",
    stroke: "#A22531",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 4.00033V2.83366C4.6665 2.52424 4.78942 2.22749 5.00821 2.0087C5.22701 1.78991 5.52375 1.66699 5.83317 1.66699H8.1665C8.47592 1.66699 8.77267 1.78991 8.99146 2.0087C9.21025 2.22749 9.33317 2.52424 9.33317 2.83366V4.00033M11.0832 4.00033V12.167C11.0832 12.4764 10.9603 12.7732 10.7415 12.9919C10.5227 13.2107 10.2259 13.3337 9.9165 13.3337H4.08317C3.77375 13.3337 3.47701 13.2107 3.25821 12.9919C3.03942 12.7732 2.9165 12.4764 2.9165 12.167V4.00033H11.0832Z",
    stroke: "#A22531",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8335 6.91699V10.417",
    stroke: "#A22531",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1665 6.91699V10.417",
    stroke: "#A22531",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12899_13746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTrashSmallIcon);
export default __webpack_public_path__ + "static/media/RedTrashSmallIcon.1a1b70e238201e40eb3208dd5aadcef8.svg";
export { ForwardRef as ReactComponent };